/**
 * Generated by orval
 * Do not edit manually.
 * IP Fabric API
 * IP Fabric API documentation. For details see [IP Fabric API documentation](https://docs.ipfabric.io/main/IP_Fabric_API/)
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  PostPreparedRequests201,
  PostPreparedRequestsParams,
} from '../../schemas';

import { apiClient } from '../../../apiClient';

/**
 * Prepares a request with cached request data to be called later with a returned ID
 * @summary Prepare request
 */
export const postPreparedRequests = (
  postPreparedRequestsBody: unknown,
  params: PostPreparedRequestsParams,
  signal?: AbortSignal,
) => {
  return apiClient<PostPreparedRequests201>({
    url: `/prepared-requests`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: postPreparedRequestsBody,
    params,
    signal,
  });
};

export const getPostPreparedRequestsMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postPreparedRequests>>,
    TError,
    { data: unknown; params: PostPreparedRequestsParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postPreparedRequests>>,
  TError,
  { data: unknown; params: PostPreparedRequestsParams },
  TContext
> => {
  const mutationKey = ['postPreparedRequests'];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      'mutationKey' in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postPreparedRequests>>,
    { data: unknown; params: PostPreparedRequestsParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postPreparedRequests(data, params);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostPreparedRequestsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postPreparedRequests>>
>;
export type PostPreparedRequestsMutationBody = unknown;
export type PostPreparedRequestsMutationError = void;

/**
 * @summary Prepare request
 */
export const usePostPreparedRequests = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postPreparedRequests>>,
      TError,
      { data: unknown; params: PostPreparedRequestsParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postPreparedRequests>>,
  TError,
  { data: unknown; params: PostPreparedRequestsParams },
  TContext
> => {
  const mutationOptions = getPostPreparedRequestsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Executes the saved request with the given ID
 * @summary Execute prepared request
 */
export const getPreparedRequestsPreparedRequestIdExecute = (
  preparedRequestId: string,
  signal?: AbortSignal,
) => {
  return apiClient<unknown>({
    url: `/prepared-requests/${preparedRequestId}/execute`,
    method: 'GET',
    signal,
  });
};

export const getGetPreparedRequestsPreparedRequestIdExecuteQueryKey = (
  preparedRequestId: string,
) => {
  return [`/prepared-requests/${preparedRequestId}/execute`] as const;
};

export const getGetPreparedRequestsPreparedRequestIdExecuteQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getPreparedRequestsPreparedRequestIdExecute>
  >,
  TError = unknown,
>(
  preparedRequestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPreparedRequestsPreparedRequestIdExecute>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetPreparedRequestsPreparedRequestIdExecuteQueryKey(preparedRequestId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPreparedRequestsPreparedRequestIdExecute>>
  > = ({ signal }) =>
    getPreparedRequestsPreparedRequestIdExecute(preparedRequestId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!preparedRequestId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPreparedRequestsPreparedRequestIdExecute>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPreparedRequestsPreparedRequestIdExecuteQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getPreparedRequestsPreparedRequestIdExecute>>
  >;
export type GetPreparedRequestsPreparedRequestIdExecuteQueryError = unknown;

export function useGetPreparedRequestsPreparedRequestIdExecute<
  TData = Awaited<
    ReturnType<typeof getPreparedRequestsPreparedRequestIdExecute>
  >,
  TError = unknown,
>(
  preparedRequestId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPreparedRequestsPreparedRequestIdExecute>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getPreparedRequestsPreparedRequestIdExecute>
          >,
          TError,
          Awaited<
            ReturnType<typeof getPreparedRequestsPreparedRequestIdExecute>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPreparedRequestsPreparedRequestIdExecute<
  TData = Awaited<
    ReturnType<typeof getPreparedRequestsPreparedRequestIdExecute>
  >,
  TError = unknown,
>(
  preparedRequestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPreparedRequestsPreparedRequestIdExecute>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<typeof getPreparedRequestsPreparedRequestIdExecute>
          >,
          TError,
          Awaited<
            ReturnType<typeof getPreparedRequestsPreparedRequestIdExecute>
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPreparedRequestsPreparedRequestIdExecute<
  TData = Awaited<
    ReturnType<typeof getPreparedRequestsPreparedRequestIdExecute>
  >,
  TError = unknown,
>(
  preparedRequestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPreparedRequestsPreparedRequestIdExecute>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Execute prepared request
 */

export function useGetPreparedRequestsPreparedRequestIdExecute<
  TData = Awaited<
    ReturnType<typeof getPreparedRequestsPreparedRequestIdExecute>
  >,
  TError = unknown,
>(
  preparedRequestId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPreparedRequestsPreparedRequestIdExecute>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetPreparedRequestsPreparedRequestIdExecuteQueryOptions(
      preparedRequestId,
      options,
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
